/**
 * Created by Ning Jiang on 2021-06-29.
 */
import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DDayLayers, Layers} from "../view/DDayLayers";
import {DDay} from "../DDay";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite} from "gsap";
import {BlitzKriegGameMode} from "../server/BlitzKriegGameMode";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {DDayGameAssets} from "../DDayGameAssets";
import {GameHelper} from "../../core/utils/GameHelper";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";

export class WinCapScreen extends ContinueScreen {
    private _youWin: BitmapCountUp;
    private _texture: PIXI.spine.Spine | undefined;
    private _textureContainer: PIXI.Container;
    private _backgroundGFX: PIXI.Graphics;

    constructor() {
        super(DDayLayers.getLayer(Layers.SCREENS)!);
        this._backgroundGFX = new PIXI.Graphics();
        this._backgroundGFX.visible = false;
        this._textureContainer = new PIXI.Container();
        this.setOverlayProps();
        const style = {
            fontName: DDayGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
        };
        this._youWin = new BitmapCountUp(style);
        this._youWin.anchor = new PIXI.Point(0.5, 0.5);
        this._youWin.position.set(360, 460);
    }

    protected setOverlayProps(): void {
        if (this._backgroundGFX) {
            const bounds: ScreenBounds = NolimitApplication.screenBounds;
            this._backgroundGFX.clear();
            this._backgroundGFX.beginFill(0x000000, 0.7);
            this._backgroundGFX.drawRect(bounds.left - 600, bounds.top - 300, 3 * bounds.width, 3 * bounds.height);
            this._backgroundGFX.endFill();
        }
    }

    public show(onContinueCallBack: () => void) {
        this._container.addChild(this._backgroundGFX, this._textureContainer, this._youWin);
        this._youWin.text = `55555x`;
        this._backgroundGFX.visible = true;
        if (!this._texture) {
            this.createTextures();
        }
        this._texture!.visible = true;
        this._texture!.state.setAnimation(0, "max_win", true);
        this._backgroundGFX.alpha = 1;
        this.enableContinueButton();
        super.show(onContinueCallBack);
    }

    private createTextures(): void {
        this._texture = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("capWin"));
        this._texture.visible = false;
        this._texture.position.set(360, 360);
        this._textureContainer.addChild(this._texture);
    }

    protected close(): TimelineLite {
        const tl = new TimelineLite();
        DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL);
        DDay.bigWinCountUp.getCountUpAnimation(0, DDay.model.parsedGameData.totalWin, 0).progress(1);
        DDay.bigWinCountUp.stay().progress(1);
        BlitzKriegSound.playTrack({name: BlitzKriegSound.WIN_CAP_END});
        BlitzKriegSound.fadeAndStopSound({name: BlitzKriegSound.WIN_CAP_LOOP, to: 0, duration: 100});
        BlitzKriegSound.switchMusic({name: BlitzKriegSound.MAIN_GAME_MUSIC});
        let isToggeled: boolean = false;
        if (GameHelper.isBoostedBetAllowed()) {
            isToggeled = DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET";
        }
        BlitzKriegSound.playTrack({name: "mainXbet", volume: isToggeled ? 1 : 0});
        tl.add(super.close());
        tl.add(() => {
            this._backgroundGFX.visible = false;
            this._texture!.visible = false;
            this._textureContainer.removeChild(this._texture!);
            this._texture!.destroy();
            this._texture = undefined;
            if (GameHelper.isBoostedBetAllowed()) {
                if (DDay.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "BOOSTED_BET") {
                    DDay.backgroundView.changeBackground(BlitzKriegGameMode.NORMAL, true);
                }
            }
            this._container.removeChild(this._backgroundGFX, this._textureContainer, this._youWin);
        });

        return tl;
    }

    public onOrientationChanged(): void {
        super.onOrientationChanged();
    }
}
